// extracted by mini-css-extract-plugin
export default {"PaymentsPage":"PaymentsPage_PaymentsPage__9OBoz"};